import { queryOptions, useMutation, useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  cambiarProrrateoAutomatico,
  listarProrrateoAutomatico,
  type CambiarProrrateoAutomaticoInput,
} from "../services/prorrateo-automatico-service";

export const prorrateoAutomaticoQueryOptions = queryOptions({
  queryKey: qk.adminProrrateoAutomatico,
  queryFn: listarProrrateoAutomatico,
});

export function useProrrateoAutomatico() {
  return useSuspenseQuery(prorrateoAutomaticoQueryOptions);
}

export function useCambiarProrrateoAutomatico() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CambiarProrrateoAutomaticoInput) => cambiarProrrateoAutomatico(input),
    onSuccess: (config) => {
      toastExito({
        title: config.habilitado ? "Prorrateo automático encendido" : "Prorrateo automático apagado",
        message: `${config.nombreTipo} · ${config.nombreSubtipo}`,
      });
      void qc.invalidateQueries({ queryKey: qk.adminProrrateoAutomatico });
    },
    onError: toastErrorApi,
  });
}
